import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom'
import { PullToRefresh, Button, Toast } from 'antd-mobile'
// import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";
import { POST } from '../../util/http'
import ComNumber from '../../components/com-number/com-number'
import './my.less'

const My = () => {
  const router = useHistory();
  const [state, setState] = useState({
    myInfos: {},
    rateList: [],
    isGM: window.localStorage.getItem('isGM')==1,    //当前账号是否用于演示 1:是 0:否
  })
  useEffect(() => {
    getUserPropertyProfit();
    getConfigInfo();
  }, [])

  const onRefresh = (e) => {
    getUserPropertyProfit('refresh');
    getConfigInfo('refresh');
  }
  const setData = (obj={}) => {
    setState(st => ({ ...st, ...obj }));
  }
  const getSessionData = (key, setname) => {    //数据加载比较慢，优先缓存中拿数据
    let _sessData = window.sessionStorage.getItem(key), _key = setname || key;
    _sessData = (_sessData && JSON.parse(_sessData)) || null;
    _sessData && setData({ [_key]: key='rateList' ? _sessData : { ..._sessData }});
    return !!_sessData;
  }
  const getUserPropertyProfit = async (gType) => {
    if (getSessionData('myProfitInfos', 'myInfos') && !gType) return;

    const res = await POST('getUserPropertyProfit', {});
    let _data = res.data || {};
    setData({ myInfos: _data });
    window.sessionStorage.setItem('myProfitInfos', JSON.stringify(_data));
  }
  const getConfigInfo = async (gType) => {
    if (getSessionData('rateList') && !gType) return;

    const res = await POST('getConfigInfo', {});
    let { cycleRate } = res.data || {}, _list = [];
    cycleRate = cycleRate || {};
    for(let key in cycleRate){
      _list.push({ name: key, value: cycleRate[key] });
    }
    setData({ rateList: _list });
    window.sessionStorage.setItem('rateList', JSON.stringify(_list));
  }
  const toPage = (path) => {    //申请提现 / 我要认购 / 退出登录
    router.push({ pathname: path });
    if (path=='/login') Toast.show('退出成功');
  }

  return (
    <div className="my-wrap">
      <PullToRefresh onRefresh={onRefresh}>
        <div className="part property-part">
          <h5 className='title prp-title lflex'>我的资产和收益 (MOP)</h5>
          <div className="money-box cflex">
            <ComNumber className='bignum' number={state.myInfos.totalPrincipal} isComma={true}></ComNumber>
            <p className='total-cnt'>投资本金总计</p>
            <ul className="statistic-list cflex">
              <li className="stc-item cflex scale-1px-right">
                <ComNumber className='smnum' number={state.myInfos.receivedPrincipal} isComma={true}></ComNumber>
                <p className='stc-cnt'>已回款本金</p>
              </li>
              <li className="stc-item cflex">
                <ComNumber className='smnum' number={state.myInfos.notReceivedPrincipal} isComma={true}></ComNumber>
                <p className='stc-cnt'>未回款本金</p>
              </li>
            </ul>
          </div>
          <div className="money-box cflex">
            <ComNumber className='bignum' number={state.myInfos.totalInterest} isComma={true}></ComNumber>
            <p className='total-cnt'>投资收益总计</p>
            <ul className="statistic-list cflex">
              <li className="stc-item cflex scale-1px-right">
                <ComNumber className='smnum' number={state.myInfos.receivedInterest} isComma={true}></ComNumber>
                <p className='stc-cnt'>已回款收益</p>
              </li>
              <li className="stc-item cflex">
                <ComNumber className='smnum' number={state.myInfos.notReceivedInterest} isComma={true}></ComNumber>
                <p className='stc-cnt'>未回款收益</p>
              </li>
            </ul>
          </div>
        </div>
        <div className="part income-part">
          <h5 className='title lflex'>可提现回款金额 (MOP)</h5>
          <ul className="income-list cflex">
            <li className='inc-item cflex'>
              <ComNumber number={state.myInfos.notWithdrawalAmount} isComma={true}></ComNumber>
              <p className='cnt'>可提现金额</p>
            </li>
            <li className='inc-item cflex'>
              <ComNumber number={state.myInfos.isWithdrawalAmount} isComma={true}></ComNumber>
              <p className='cnt'>已提现金额</p>
            </li>
          </ul>
          <div className="btn-box cflex">
            {state.isGM ? '' : <Button className='btn pbtn' onClick={() => toPage('/withdraw')}>申请提现</Button>}
          </div>
        </div>
        <div className="part buy-part">
          <h5 className='title lflex'>已认购资产 (MOP)</h5>
          <ul className="buy-list cflex">
            <li className='buy-item cflex'>
              <ComNumber number={state.myInfos.propertyNum} isComma={true}></ComNumber>
              <p className='cnt'>已认购资产数量</p>
            </li>
            <li className='buy-item cflex'>
              <ComNumber number={state.myInfos.propertyPrice} isComma={true}></ComNumber>
              <p className='cnt'>资产单价</p>
            </li>
            <li className='buy-item cflex'>
              <ComNumber number={state.myInfos.propertyTotalPrice} isComma={true}></ComNumber>
              <p className='cnt'>已认购资产总额</p>
            </li>
            <li className='buy-item cflex'>
              <ComNumber number={state.myInfos.totalAmount} isComma={true}></ComNumber>
              <p className='cnt'>总投资收益</p>
            </li>
          </ul>
          {!state.rateList.length ? '' :
            <div className="infos">
              <p className='iname'>认购期和回报率</p>
              <ul className='info-list'>
                {state.rateList.map((item, index) => 
                  <li className={`info-item btwflex ${index!=0?'scale-1px-top':''}`} key={index}>
                    <p className='ins-num'>{item.name}天</p>
                    <p className='ins-val'>年收益费率{item.value}%</p>
                  </li>
                )}
              </ul>
            </div>
          }
          <div className="btn-box cflex">
            {state.isGM ? '' : <Button className='btn pbtn' onClick={() => toPage('/buyProperty')}>继续认购</Button>}
          </div>
        </div>
        <div className="login-out cflex">
          <p className='login-out-btn' onClick={() => toPage('/login')}>退出登录</p>
        </div>

        {/* <div className="part chart-part">
          <h5 className='title lflex'>收益曲线</h5>
          <div className="chart-box">
            <ResponsiveContainer className='income-chart' width='100%' height='100%'>
              <AreaChart data={state.chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                <defs>
                  <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="20%" stopColor="#FDEDED" stopOpacity={1} />
                    <stop offset="80%" stopColor="#FFEFEE" stopOpacity={0.15} />
                  </linearGradient>
                </defs>
                <XAxis dataKey="date" stroke='#1A1836' fontSize={12} tickLine={false} interval={0} />
                <YAxis axisLine={false} stroke='#1A1836' fontSize={12} tickLine={false} interval={0} />
                <CartesianGrid className='chart-grid' strokeDasharray="3" vertical={false} horizontalCoordinatesGenerator={(props) => {
                  let { height, y, niceTicks } = props.yAxis||{}, _len = (niceTicks||[]).length || 0;
                  let yPos = [], _dis = height/(_len ? _len-1 : 0), _start = height+y;    //网格线第一个点和x重合(坐标从图表顶部(包括top值)算起), 数量为y轴展示的数据长度(0除外)
                  for(let i=0; i<_len; i++){
                    yPos.push(_start - _dis*i);
                  }
                  return yPos;
                }} />
                <Tooltip formatter={value => [value, "收益"]} />
                <Area type="monotone" dataKey="profit" stroke="#FF7928" fillOpacity={1} fill="url(#colorUv)" />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div> */}
      </PullToRefresh>
    </div>
  )
}

export default My;